export class StaffLogin {
    public company_code: string;
    public username: string;
    public password: string;
}